var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collections container" }, [
    _c("h3", [_vm._v("Collections")]),
    _c(
      "div",
      { staticClass: "collections__grid" },
      _vm._l(_vm.collections, function(collection) {
        return _c(
          "a",
          { staticClass: "collections__tile", attrs: { href: collection.url } },
          [
            _c("img", {
              staticClass: "collections__tile-image",
              attrs: { src: collection.image, alt: collection.alt }
            }),
            _c("div", { staticClass: "collections__tile-text" }, [
              _c("h5", [_vm._v(_vm._s(collection.title))])
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }